import { useMutation, useQueryClient } from 'react-query';

import { putArchiveObjectDoc } from 'api/objectDocs/deleteObjectDoc';

const useArchiveObjectDoc = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: archiveObjectDoc,
    isLoading,
  } = useMutation(putArchiveObjectDoc, {
    onSuccess: () => {
      queryClient.invalidateQueries(['useGetObjectDocs', 'ObjectDocsDetailPage']);
    },
  });

  return {
    isSuccess,
    archiveObjectDoc,
    isLoading,
  };
};

export default useArchiveObjectDoc;
